import React from "react";
import "./ErrorMessage.css";

interface ErrorMessageProps {
  message: string;
  onRetry?: () => void;
  onDismiss?: () => void;
  isTimeout?: boolean;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ 
  message, 
  onRetry, 
  onDismiss,
  isTimeout
}) => {
  return (
    <div className={`error-message ${isTimeout ? 'timeout-error' : ''}`}>
      <div className="error-content">
        <span className="error-icon">{isTimeout ? '⏱️' : '⚠️'}</span>
        <span className="error-text">{message}</span>
        {isTimeout && (
          <div className="error-hint">
            Tipp: Versuchen Sie es erneut oder überprüfen Sie Ihre Internetverbindung
          </div>
        )}
      </div>
      <div className="error-actions">
        {onRetry && (
          <button 
            className="error-button retry-button" 
            onClick={onRetry}
          >
            {isTimeout ? 'Wiederholen' : 'Erneut versuchen'}
          </button>
        )}
        {onDismiss && (
          <button 
            className="error-button dismiss-button" 
            onClick={onDismiss}
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorMessage;